import {
  CreateAssessmentDocument,
  CreateAssessmentMutation,
  CreateAssessmentMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreateAssessmentPayload =
  CreateAssessmentMutation['atsMutations']['createAtsAssessment']

export type AtsAssessment = CreateAssessmentPayload['assessment']

export const useCreateAssessment = () => {
  const [createAssessment, { loading }] = useMutation(CreateAssessmentDocument, {
    extractorFn: (data: CreateAssessmentMutation) => data.atsMutations.createAtsAssessment,
  })

  return {
    loading,
    create(variables: CreateAssessmentMutationVariables) {
      return createAssessment({
        variables,
      })
    },
  }
}
